/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import Menu from '../../../components/Peyks/Menu'
import peykIcon from '../../../assets/svg/PMotorCycle.svg'

import { get, put } from '../../../services/http'

import { useForm } from 'react-hook-form'
import { ToRial } from '../../../services/toRial'
import { ToastContainer } from 'react-toastify'
import { notify } from '../../../components/Toast'

export default function index() {

  const [clickButton, setClickButton] = useState(false)
  const [rent, setRent] = useState(0)
  const [description, setDescription] = useState('')
  const [id, setId] = useState('')

  const { register, handleSubmit } = useForm()

  const onSubmit = (data, e) => {
    setClickButton(true)
    e.preventDefault()
    put(`/api/admin/peyks/pay/update/${id}?token=${token}`, {
      price: data.price,
      details: data.details
    }).then(response => {
      if (response.data.success) {
        setClickButton(false)
        setRent(data.price)
        setDescription(data.details)
        notify('success', 'با موفقیت آپدیت شد')
      }
    }).catch(error => {
      setClickButton(false)
      console.log(error)
    })
  }

  const token = localStorage.getItem('token')

  document.title = 'مالی و حسابداری'

  useEffect(() => {
    get(`/api/admin/peys-peyks?token=${token}`)
      .then(response => {
        console.log(response)
        setRent(response.data.data[0].price)
        setDescription(response.data.data[0].details)
        setId(response.data.data[0]._id)
      })
  }, [token])

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'accounting'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={peykIcon} width={30} alt='resturantIcon' />
              </div>
              <div className='text'>
                هزینه هر سفر
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * از طریق فرم زیر میتوانید به تغییر قیمت اقدام کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات هزینه
              <hr />
            </div>
            <div className='row' style={{ padding: '0.5em 1em',borderRadius: '5px' , boxSizing: 'border-box', backgroundColor: '#F2F2F2' }}>
              <div className="rowPrice">
                <span>هزینه هر سفر : </span>
                <span>{ToRial(String(rent))}</span>
                <span> تومان </span> / 
                <span> توضیحات : </span>
                <span> {description} </span>
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>هزینه هر سفر * : </label>
                <input id='foodName' {...register("price", { required: true, minLength: 3 })} type='number' placeholder='92...' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodName'>توضیحات * :</label>
                <input id='foodName' {...register("details", { required: true, minLength: 3 })} type='text' placeholder='هزینه' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپدیت ...' : 'آپدیت هزینه پیک'}</button>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
